import SvgIcoOrientation from './SvgIcoOrientation';

export default SvgIcoOrientation;
